<div class="material-slide-toggle">
	<div *ngIf="loading" 
		class="row spinner-row">
		<vtr-spinner></vtr-spinner>
	</div>
	<div *ngIf="!loading">
		<mat-slide-toggle #toggle 
			[id]="id + '_checkbox'" 
			[name]="id" 
			[checked]="value"
			[disabled]="disabled" 
			[aria-label]="ariaLabel" 
			(change)="onChange(toggle)">
		</mat-slide-toggle>
		<label 
			class="custom-control-label" 
			*ngIf="label !== ''"
			[for]="id + '_checkbox'">
			{{label}}
		</label>
	</div>
</div>
